import { createFileRoute } from '@tanstack/react-router';

import { ApplicationDetailPage, applicationQueryOptions } from '@/features/applications';

export const Route = createFileRoute('/_authed/applications/$applicationId')({
  staticData: { tours: ['platform.applications.detail'] },
  loader: async ({ context, params }) => {
    const application = await context.queryClient.query({
      ...applicationQueryOptions(params.applicationId),
      staleTime: 'static',
    });
    // The shell's breadcrumb reads this; the page itself subscribes to the query.
    return { crumb: application.brandName };
  },
  component: ApplicationDetailPage,
});
